// Generated by ts-to-zod
import { z } from "zod";
export const boardSchema = z.object({
  id: z.string(),
  parentId: z.string(),
  kind: z.literal("board"),
  source: z.string(),
  sitesVisibility: z.string(),
  userId: z.string(),
  siteId: z.string(),
  name: z.string(),
  description: z.string(),
  thumbnailUrl: z.string().nullable(),
  createdAt: z.number(),
  teamAvailability: z.union([z.literal("on"), z.literal("off")])
}).strict();
export const managerMediaTypeSchema = z.union([z.literal("picture"), z.literal("music"), z.literal("document"), z.literal("video"), z.literal("archive"), z.literal("shape"), z.literal("swf"), z.literal("site_icon"), z.literal("secure_picture"), z.literal("secure_music"), z.literal("secure_document"), z.literal("secure_video"), z.literal("secure_archive"), z.literal("secure_raw"), z.literal("3d")]);
export const sourceSchema = z.union([z.literal("all"), z.literal("private"), z.literal("public"), z.literal("trash"), z.literal("favorites"), z.literal("visitorsUploads"), z.literal("custom"), z.literal("ntt"), z.literal("shutterStock"), z.literal("shutterStockVideo"), z.literal("unsplash"), z.literal("home"), z.literal("boards"), z.literal("yell"), z.literal("enterprise"), z.literal("multiSearch"), z.literal("computer"), z.literal("facebook"), z.literal("dribble"), z.literal("drive"), z.literal("dropbox"), z.literal("instagram"), z.literal("flickr"), z.literal("deviantArt"), z.literal("googlePhotos"), z.literal("wixSite"), z.literal("wixVideo"), z.literal("wixel"), z.literal("link"), z.literal("vimeo"), z.literal("external"), z.literal("photoStock")]);
export const namespaceSchema = z.union([z.literal("all"), z.literal("_nsWixMusic"), z.literal("_nsWixVideo"), z.literal("_nsArtStore"), z.literal("_nsPortfolio"), z.literal("_nsLogos"), z.literal("_nsDigitalProduct")]);
export const operationStatusSchema = z.union([z.literal("INPROGRESS"), z.literal("READY"), z.literal("PENDING"), z.literal("FAILED")]);
export const pagingSchema = z.object({
  size: z.number().optional(),
  cursor: z.string().optional().nullable()
}).strict();
export const sortDirectionSchema = z.union([z.literal("asc"), z.literal("desc")]);
export const sortingOptionsSchema = z.object({
  order: z.union([z.literal("date"), z.literal("name")]),
  direction: sortDirectionSchema
}).strict();
export const baseFileSchema = z.object({
  createdAt: z.number().min(1),
  fileInfo: z.null(),
  fileSize: z.number().min(1),
  fileUrl: z.string(),
  folderId: z.string(),
  hasMoreItemsInThisCategory: z.boolean(),
  id: z.string(),
  kind: z.literal("file"),
  labels: z.array(z.string()),
  mimeType: z.string(),
  name: z.string(),
  originalUrl: z.string().url(),
  previewUrl: z.string().url(),
  readOnly: z.null(),
  siteId: z.string().uuid(),
  siteMediaToken: z.string(),
  source: sourceSchema,
  sourceUrl: z.string().url().nullable(),
  tags: z.array(z.string()),
  transcodingStatus: operationStatusSchema.optional(),
  thumbnailUrl: z.string().url(),
  updatedAt: z.number(),
  userId: z.string().regex(/^other:wix-code$|^unknown$|^((member|anonymous):)?[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/)
}).strict();
export const commonFileSchema = baseFileSchema.extend({
  fileInput: z.null(),
  fileOutput: z.null(),
  videoPreviewUrls: z.null()
});
export const siteIconFileSchema = commonFileSchema.extend({
  mediaType: z.literal("site_icon"),
  width: z.number(),
  height: z.number()
});
export const shapeFileSchema = commonFileSchema.extend({
  mediaType: z.literal("shape"),
  width: z.number().nullable(),
  height: z.number().nullable()
});
export const swfFileSchema = commonFileSchema.extend({
  mediaType: z.literal("swf"),
  width: z.number().nullable(),
  height: z.number().nullable()
});
export const archiveFileSchema = commonFileSchema.extend({
  mediaType: z.literal("archive"),
  width: z.null(),
  height: z.null()
});
export const secureArchiveFileSchema = commonFileSchema.extend({
  mediaType: z.literal("secure_archive"),
  width: z.null(),
  height: z.null()
});
export const secureDocumentFileSchema = commonFileSchema.extend({
  mediaType: z.literal("secure_document"),
  width: z.null(),
  height: z.null()
});
export const secureRawFileSchema = commonFileSchema.extend({
  mediaType: z.literal("secure_raw"),
  width: z.number().nullable(),
  height: z.number().nullable()
});
export const baseAudioSchema = z.object({
  audio_bitrate: z.number(),
  duration: z.number().min(1),
  format: z.string().min(3),
  key: z.string().min(1),
  secure: z.boolean(),
  status: operationStatusSchema,
  tag: z.string()
}).strict();
export const audioSchema = baseAudioSchema.extend({
  url: z.string().regex(/^mp3\/.*\.mp3$/),
  quality: z.string().min(1)
});
export const audioFileOutputSchema = z.object({
  audio: z.array(audioSchema)
}).strict();
export const id3Schema = z.object({
  album_name: z.string().optional(),
  track_artist: z.string().optional(),
  track_name: z.string().optional(),
  track_number: z.string().optional(),
  track_genre: z.string().optional(),
  track_year: z.number().optional()
}).strict();
export const audioFileInputSchema = z.object({
  bitrate: z.number().min(1),
  channels: z.number(),
  duration: z.number().min(1),
  format: z.string().min(3),
  id3: id3Schema.optional(),
  sample_rate: z.number()
}).strict();
export const baseAudioFileSchema = baseFileSchema.extend({
  fileInput: audioFileInputSchema,
  height: z.null(),
  width: z.null(),
  videoPreviewUrls: z.null()
});
export const secureAudioSchema = baseAudioSchema.extend({
  url: z.string().regex(/^preview\/.*\.mp3$/).optional(),
  quality: z.string().min(1).optional()
});
export const secureAudioFileOutputSchema = z.object({
  audio: z.array(secureAudioSchema)
}).strict();
export const secureAudioFileSchema = baseAudioFileSchema.extend({
  mediaType: z.literal("secure_music"),
  fileOutput: secureAudioFileOutputSchema
});
export const labelSchema = z.object({
  description: z.string(),
  score: z.number()
}).strict();
export const faceSchema = z.object({
  confidence: z.number(),
  height: z.number().min(1),
  width: z.number().min(1),
  x: z.number(),
  y: z.number()
}).strict();
export const rgbSchema = z.object({
  r: z.number(),
  g: z.number(),
  b: z.number(),
  pixel_fraction: z.number().optional(),
  score: z.number().optional()
}).strict();
export const explicitContentSchema = z.object({
  likelihood: z.string(),
  name: z.string()
}).strict();
export const pictureFileInputSchema = z.object({
  label: z.array(labelSchema).optional(),
  face: z.array(faceSchema).optional(),
  crop_hint: z.array(faceSchema).optional(),
  color_palette: z.array(rgbSchema).optional(),
  prominent_color: z.array(rgbSchema).optional(),
  animated: z.boolean().optional(),
  text_in_image: z.boolean().optional(),
  explicit_content: z.array(explicitContentSchema).optional(),
  format: z.string().optional()
}).strict();
export const basePictureFileSchema = baseFileSchema.extend({
  fileInput: pictureFileInputSchema.nullable(),
  height: z.number(),
  width: z.number(),
  videoPreviewUrls: z.null()
});
export const previewPictureSchema = z.object({
  height: z.number().min(0),
  key: z.string().regex(/^(image\.preview)|()$/),
  name: z.string(),
  secure: z.literal(false),
  status: operationStatusSchema,
  url: z.string().regex(/^media\/(.*)/),
  width: z.number().min(0),
  format: z.string().optional()
}).strict();
export const previewPictureFileOutputSchema = z.object({
  preview: z.array(previewPictureSchema)
}).strict();
export const pictureFileSchema = basePictureFileSchema.extend({
  mediaType: z.literal("picture"),
  fileOutput: z.null()
});
export const securePictureFileSchema = basePictureFileSchema.extend({
  mediaType: z.literal("secure_picture"),
  fileOutput: previewPictureFileOutputSchema
});
export const adaptiveVideoSchema = z.object({
  format: z.literal("hls"),
  key: z.string(),
  status: operationStatusSchema,
  tag: z.string(),
  url: z.string().regex(/^site\/media\/video\/(.*)\/hls$/)
}).strict();
export const videoOutputSchema = z.object({
  audio_bitrate: z.number(),
  display_aspect_ratio: z.string().optional(),
  duration: z.number().min(1),
  format: z.string().min(3),
  fps: z.union([z.string(), z.number()]).optional(),
  height: z.number().min(1),
  key: z.string().optional(),
  kind: z.string().regex(/^video$/).optional(),
  quality: z.string().min(1).optional(),
  secure: z.boolean(),
  status: operationStatusSchema,
  tag: z.string().optional(),
  url: z.string().regex(/^video\/(.*)\.mp4$/).optional(),
  video_bitrate: z.number().optional(),
  width: z.number().min(1)
}).strict();
export const imageOutputSchema = z.object({
  format: z.string().min(3),
  height: z.number().min(1),
  key: z.string().optional(),
  secure: z.literal(false),
  status: operationStatusSchema,
  url: z.string().regex(/^media\/(.*)\.jpg$/),
  width: z.number().min(1)
}).strict();
export const videoFileInputSchema = z.object({
  audio_bitrate: z.number(),
  display_aspect_ratio: z.string(),
  duration: z.number(),
  fps: z.union([z.string(), z.number()]),
  height: z.number().min(1),
  rotation: z.number(),
  sample_aspect_ratio: z.string(),
  type: z.literal("video"),
  video_bitrate: z.number(),
  width: z.number().min(1)
}).strict();
export const videoFileOutputSchema = z.object({
  image: z.array(imageOutputSchema),
  video: z.array(videoOutputSchema),
  storyboard: z.array(videoOutputSchema).optional(),
  adaptive_video: z.array(adaptiveVideoSchema).optional(),
  clip: z.array(videoOutputSchema).optional(),
  trailer: z.array(videoOutputSchema).optional()
}).strict();
export const baseVideoFileSchema = baseFileSchema.extend({
  fileInput: videoFileInputSchema,
  fileOutput: videoFileOutputSchema
});
export const secureVideoFileSchema = baseVideoFileSchema.extend({
  mediaType: z.literal("secure_video"),
  height: z.number().nullable(),
  width: z.number().nullable(),
  videoPreviewUrls: z.array(z.string())
});
export const videoFileSchema = baseVideoFileSchema.extend({
  mediaType: z.literal("video"),
  height: z.number(),
  width: z.number(),
  videoPreviewUrls: z.array(z.string().url())
});
export const listFoldersParamsSchema = z.object({
  paging: pagingSchema,
  sort: sortingOptionsSchema,
  mediaType: z.string().optional(),
  language: z.string().optional(),
  onlyCurrentUser: z.boolean().optional(),
  categories: z.array(z.string()).optional(),
  recommendedCategories: z.array(z.string()).optional(),
  searchCacheKiller: z.string().optional(),
  searchQuery: z.string().optional()
}).strict();
export const mediaManagerFolderSchema = z.object({
  id: z.string(),
  siteId: z.string(),
  kind: z.literal("folder"),
  source: sourceSchema,
  name: z.string(),
  siteMediaToken: z.string().optional(),
  parentId: z.string().optional().nullable(),
  isInTrash: z.boolean().optional(),
  isNew: z.boolean().optional(),
  createdAt: z.number().optional(),
  updatedAt: z.number().optional(),
  userId: z.string().optional(),
  tags: z.array(z.string()).optional(),
  systemTags: z.array(z.string()).optional(),
  categoryId: z.string().optional(),
  mediaType: z.string().optional(),
  filesCount: z.number().optional()
}).strict();
export const listItemsParamsPrivateSchema = z.object({
  mediaType: z.string().regex(/^(,|picture|music|document|video|archive|shape|swf|site_icon|secure_picture|secure_music|secure_document|secure_video|secure_archive|secure_raw|3d)*$/).optional(),
  paging: pagingSchema,
  sort: sortingOptionsSchema,
  language: z.string().optional(),
  onlyCurrentUser: z.boolean().optional(),
  categories: z.array(z.string()).optional(),
  recommendedCategories: z.array(z.string()).optional(),
  searchCacheKiller: z.string().optional(),
  searchQuery: z.string().optional()
}).strict();
export const listItemsParamsSchema = listItemsParamsPrivateSchema;
export const searchItemsParamsSchema = z.object({
  mediaType: z.string().regex(/^(,|picture|music|document|video|archive|shape|swf|site_icon|secure_picture|secure_music|secure_document|secure_video|secure_archive|secure_raw|3d)*$/).optional(),
  paging: pagingSchema,
  sort: sortingOptionsSchema,
  language: z.string().optional(),
  onlyCurrentUser: z.boolean().optional(),
  categories: z.array(z.string()).optional(),
  recommendedCategories: z.array(z.string()).optional(),
  searchCacheKiller: z.string().optional(),
  searchQuery: z.string().optional(),
  mediaTypes: z.record(z.boolean()).optional()
}).strict();
export const audioFileSchema = baseAudioFileSchema.extend({
  mediaType: z.literal("music"),
  fileOutput: audioFileOutputSchema
});
export const model3DFileSchema = baseFileSchema.extend({
  mediaType: z.literal("3d"),
  width: z.null(),
  height: z.null(),
  fileOutput: previewPictureFileOutputSchema.nullable(),
  fileInput: z.null(),
  videoPreviewUrls: z.null()
});
export const documentFileSchema = baseFileSchema.extend({
  mediaType: z.literal("document"),
  width: z.null(),
  height: z.null(),
  fileOutput: previewPictureFileOutputSchema.nullable(),
  fileInput: z.null(),
  videoPreviewUrls: z.null()
});
export const listFoldersResultSchema = z.object({
  data: z.array(mediaManagerFolderSchema),
  paging: pagingSchema.optional()
}).strict();
export const mediaManagerFileSchema = z.discriminatedUnion("mediaType", [pictureFileSchema, securePictureFileSchema, audioFileSchema, secureAudioFileSchema, siteIconFileSchema, shapeFileSchema, swfFileSchema, videoFileSchema, secureVideoFileSchema, model3DFileSchema, archiveFileSchema, secureArchiveFileSchema, documentFileSchema, secureDocumentFileSchema, secureRawFileSchema]);
export const searchItemsResultSchema = z.object({
  data: z.array(mediaManagerFileSchema),
  paging: pagingSchema.optional()
}).strict();
export const listItemsResultSchema = z.object({
  data: z.array(mediaManagerFileSchema),
  paging: pagingSchema.optional()
}).strict();
//# sourceMappingURL=zodSchemas.strict.js.map